import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Modal } from '@reveni-io/reveni-ui'

import InfoPackingListText from './InfoPackingListText/InfoPackingListText'
import * as Styles from './styles'

const GeneratePackingListModal = ({ show, onClose, onGeneratePackingList, selectedParcels, loading }) => {
  const { t } = useTranslation()

  const handleGeneratePackingList = () => {
    const parcelIds = selectedParcels?.map(parcel => parcel.id)
    onGeneratePackingList(parcelIds)
  }

  return (
    <Modal
      title={t('Lista de empaquetado')}
      show={show}
      size="l"
      onClose={onClose}
      actions={
        <Styles.ActionsContainer>
          <Button variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            onClick={handleGeneratePackingList}
            loading={loading}
            loadingLabel={t('Generando fichero...')}
            defaultLabel={t('Generar fichero')}
            disabled={loading || !selectedParcels?.length}
          />
        </Styles.ActionsContainer>
      }
    >
      <Styles.MainContainer>
        <InfoPackingListText selectedParcels={selectedParcels} />
      </Styles.MainContainer>
    </Modal>
  )
}

export default GeneratePackingListModal
